import React from "react";
import { Icon } from "@iconify/react";

const ModalContainer = ({
  open,
  setOpen,
  children,
  title,
  subTitle,
  secondary,
  padding,
  footer,
  className,
  childClassname,
  header,
  onClickOutside,
}) => {
  return (
    <div
      className={`fixed z-[51] top-0 left-0 w-full h-full items-center justify-center bg-gray-500 bg-opacity-75 ${
        open ? "flex" : "hidden"
      } ${className}`}
      style={{
        transform: "translateZ(0)",
      }}
    >
      <div
        className="flex flex-1 h-full"
        onClick={() => onClickOutside?.()}
      ></div>
      <div
        className={`flex flex-col w-full h-full items-center ${
          childClassname || "max-w-[887px]"
        }`}
      >
        <div
          className="flex flex-1 flex-col w-full "
          onClick={() => onClickOutside?.()}
        ></div>
        <div
          className={`w-full rounded-b-lg shadow-md max-h-[90vh] flex items-center justify-center mx-4 overflow-scroll scroll-hide ${
            childClassname || "max-w-[887px]"
          }`}
        >
          <div
            className={`${
              padding || "pt-6 px-4 pb-4 sm:p-16"
            }  z-10 flex flex-col gap-2 relative`}
          >
            {children}
          </div>
        </div>
        <div
          className="flex flex-1 flex-col w-full "
          onClick={() => onClickOutside?.()}
        ></div>
      </div>
      <div
        className="flex flex-1 h-full"
        onClick={() => onClickOutside?.()}
      ></div>
    </div>
  );
};

export default ModalContainer;
